import defaultLocales from 'globals/locales/default';

const { customer, reference, createdAt, reportStatus } = defaultLocales;

export const headLabels = [customer, reference, createdAt, reportStatus];

export const dummyPagination = {
  itemsPerPage: 10,
  currentPage: 1,
  numberOfPages: 100,
};
